import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Hero from './Hero';
import TechEcosystem from './TechEcosystem';
import Services from './Services';
import Marketplace from './Marketplace';
import Results from './Results';
import Process from './Process';
import ClientStories from './ClientStories';
import FinalCTA from './FinalCTA';
import Footer from '../Footer';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';

export default function HomePage() {
  const { events: gaEvents } = useGoogleAnalytics();
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      // Allow sections to mount before scrolling.
      requestAnimationFrame(() => {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    } else {
      window.scrollTo(0, 0);
    }
    gaEvents.pageView('home_2026');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-ink font-sans antialiased">
      <Navbar />
      <main>
        <Hero />
        <TechEcosystem />
        <Services />
        <Marketplace />
        <Results />
        <Process />
        <ClientStories />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
